import React, { useState, useEffect } from "react";
import {
    Grid,
    Container,
    Typography,
    Table,
    TableBody,
    TableRow,
    TableCell,
    TablePagination,
    TableHead,
    Modal,
} from "@mui/material";
import Box from "@mui/material/Box";
import { useNavigate } from "react-router-dom";
import { images } from "../../config/images";
import { Button } from "../../components/Button/button";
import KeyboardBackspaceIcon from "@mui/icons-material/KeyboardBackspace";
import { getPlants, getProducts, getSizes } from "../Dashboard/services";
import SubProductionChart from "./SubProductionChart";
import "./ProductionAnalytics.css";

const tableData = {
    "2022": [
        { month: "Apr-2023", produced_pair_in_nos: 140, cum_prods_till_month_1: 190 },
        { month: "May-2023", produced_pair_in_nos: 210, cum_prods_till_month_1: 300 },
        { month: "Jun-2023", produced_pair_in_nos: 190, cum_prods_till_month_1: 510 },
        { month: "Jul-2023", produced_pair_in_nos: 210, cum_prods_till_month_1: 700 },
        { month: "Aug-2023", produced_pair_in_nos: 220, cum_prods_till_month_1: 910 },
        { month: "Sep-2023", produced_pair_in_nos: 260, cum_prods_till_month_1: 1100 },
        { month: "Oct-2023", produced_pair_in_nos: 240, cum_prods_till_month_1: 1420 },
        { month: "Nov-2023", produced_pair_in_nos: 280, cum_prods_till_month_1: 1600 },
        { month: "Dec-2023", produced_pair_in_nos: 220, cum_prods_till_month_1: 1950 },
        { month: "Jan-2024", produced_pair_in_nos: 250, cum_prods_till_month_1: 2110 },
        { month: "Feb-2024", produced_pair_in_nos: 310, cum_prods_till_month_1: 2410 },
        { month: "Mar-2024", produced_pair_in_nos: 330, cum_prods_till_month_1: 2850 }
    ],
    "2023": [
        { month: "Apr-2023", produced_pair_in_nos: 150, cum_prods_till_month_1: 150 },
        { month: "May-2023", produced_pair_in_nos: 200, cum_prods_till_month_1: 350 },
        { month: "Jun-2023", produced_pair_in_nos: 180, cum_prods_till_month_1: 530 },
        { month: "Jul-2023", produced_pair_in_nos: 220, cum_prods_till_month_1: 750 },
        { month: "Aug-2023", produced_pair_in_nos: 210, cum_prods_till_month_1: 960 },
        { month: "Sep-2023", produced_pair_in_nos: 240, cum_prods_till_month_1: 1200 },
        { month: "Oct-2023", produced_pair_in_nos: 260, cum_prods_till_month_1: 1460 },
        { month: "Nov-2023", produced_pair_in_nos: 230, cum_prods_till_month_1: 1690 },
        { month: "Dec-2023", produced_pair_in_nos: 250, cum_prods_till_month_1: 1940 },
        { month: "Jan-2024", produced_pair_in_nos: 270, cum_prods_till_month_1: 2210 },
        { month: "Feb-2024", produced_pair_in_nos: 300, cum_prods_till_month_1: 2510 },
        { month: "Mar-2024", produced_pair_in_nos: 320, cum_prods_till_month_1: 2830 }
    ],
    "2024": [
        { month: "Apr-2024", produced_pair_in_nos: 160, cum_prods_till_month_1: 160 },
        { month: "May-2024", produced_pair_in_nos: 190, cum_prods_till_month_1: 350 },
        { month: "Jun-2024", produced_pair_in_nos: 210, cum_prods_till_month_1: 560 },
        { month: "Jul-2024", produced_pair_in_nos: 250, cum_prods_till_month_1: 810 },
        { month: "Aug-2024", produced_pair_in_nos: 270, cum_prods_till_month_1: 1080 },
        { month: "Sep-2024", produced_pair_in_nos: 300, cum_prods_till_month_1: 1380 },
        { month: "Oct-2024", produced_pair_in_nos: 320, cum_prods_till_month_1: 1700 },
        { month: "Nov-2024", produced_pair_in_nos: 290, cum_prods_till_month_1: 1990 },
        { month: "Dec-2024", produced_pair_in_nos: 310, cum_prods_till_month_1: 2300 },
        { month: "Jan-2025", produced_pair_in_nos: 330, cum_prods_till_month_1: 2630 },
        { month: "Feb-2025", produced_pair_in_nos: 350, cum_prods_till_month_1: 2980 },
        { month: "Mar-2025", produced_pair_in_nos: 380, cum_prods_till_month_1: 3360 }
    ]
};

const SubProduction = () => {
    const navigate = useNavigate();

    const [selectedPlants, setSelectedPlants] = useState();
    const [selectedProducts, setSelectedProducts] = useState();
    const [selectedSize, setSelectedSize] = useState();
    const [selectedPlantId, setselectedPlantId] = useState();
    const [selectedProductId, setselectedProductId] = useState();
    const [selectedSizeId, setSelectedSizeId] = useState();
    const [selectYear, setSelectYear] = useState();

    // asynchronous function to fetch production data API
    const getData = async () => {
        try {
            const resp = await getPlants();
            setSelectedPlants(resp.data.payload);
            setselectedPlantId(resp.data.payload[0].id)
            const resp1 = await getProducts(resp.data.payload[0].id);
            setSelectedProducts(resp1.data.payload);
            setselectedProductId(resp1.data.payload[0].id);
            const resp2 = await getSizes(resp1.data.payload[0].id);
            setSelectedSize(resp2.data.payload);
            setSelectedSizeId(resp2.data.payload[0].id)
        } catch (error) {
            console.log(error);
        }
    };

    // useEffect hook to fetch data when component mounts
    useEffect(() => {
        getData();
        return () => { };
    }, []);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const resp1 = await getProducts(selectedPlantId);
                if (resp1.data.success == true) {
                    setSelectedProducts(resp1.data.payload);
                    setselectedProductId(resp1.data.payload[0]?.id);
                }
            } catch (error) {
                console.error("Error fetching data:", error);
                setSelectedProducts([]);
                setselectedProductId("");

            }
        };

        if (selectedPlantId) {
            fetchData();
        }
    }, [selectedPlantId]);

    useEffect(() => {
        const fetchData = async () => {
            try {
                const resp2 = await getSizes(selectedProductId);
                if (resp2.data.success == true) {
                    setSelectedSize(resp2.data.payload);
                    setSelectedSizeId(resp2.data.payload[0]?.id);
                }

            } catch (error) {
                console.error("Error fetching data:", error);
                setSelectedSize([]);
                setSelectedSizeId("");
            }
        }
        if (selectedProductId) {
            fetchData();
        }
    }, [selectedProductId]);


    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [selectRange, setSelectedRange] = useState([]);
    const [prodResult, setProdResult] = useState([]);
    const [inputValues, setInputValues] = useState([]);
    // Function to calculate start and end dates based on fiscal year
    const calculateFiscalYearDates = (year) => {
        const fiscalYearStart = new Date(`${year}-04-01`);
        const fiscalYearEnd = new Date(`${parseInt(year) + 1}-03-31`);
        setStartDate(fiscalYearStart);
        setEndDate(fiscalYearEnd);
    };

    // Call this function when fiscal year changes
    useEffect(() => {
        const year = selectYear
        if (year) {
            calculateFiscalYearDates(year);
        }
    }, [selectYear]);
    const generateMonthRange = (startDate, endDate) => {
        if (!startDate || !endDate) return [];

        const range = [];
        let currentDate = new Date(startDate);

        while (currentDate <= endDate) {
            range.push({
                id: currentDate.getTime(), // Unique ID for each month
                month: currentDate.toLocaleString("default", { month: "short" }), // e.g., "Apr"
                year: currentDate.getFullYear(), // Year for clarity
                label: `${currentDate.toLocaleString("default", { month: "short" })} ${'-'} ${currentDate.getFullYear()}`, // e.g., "Apr 2023"
            });
            currentDate.setMonth(currentDate.getMonth() + 1); // Move to the next month
        }

        return range;
    };

    useEffect(() => {
        if (startDate && endDate) {
            const range = generateMonthRange(startDate, endDate);
            setSelectedRange(range);
        }
    }, [startDate, endDate]);
    // Update prodResult when selectYear changes
    useEffect(() => {
        console.log("test", selectYear)
        if (tableData[selectYear]) {
            setProdResult(tableData[selectYear]);
        } else {
            setProdResult([]);
        }
    }, [selectYear]);
    return (
        <>
            <div className="containerWrap">
                <Container maxWidth="xxl">
                    <div className="packingHeader-wrap">
                        <div className="packingTitle-wrap">
                            <KeyboardBackspaceIcon
                                onClick={() => navigate(-1)}
                                className="backArrow"
                            />
                            <Typography
                                variant="h5"
                                className="packingTitle"
                                gutterBottom
                                onClick={() => navigate(-1)}
                            >
                                Production Summary
                            </Typography>
                        </div>
                        <div className="dispatchSummary-print-section">
                            <Box className="select-div" width="180px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    // defaultValue="all"
                                    value={selectedPlantId}
                                    onChange={(event) =>
                                        setselectedPlantId(event.target.value)
                                    }
                                    required
                                >
                                    <option value="" disabled> Select Plant</option>
                                    {selectedPlants ? (
                                        selectedPlants.map((event) => (
                                            <option value={event.id}>{event.name}</option>
                                        ))
                                    ) : (
                                        <option>{"No Data Found"}</option>
                                    )}
                                </select>
                            </Box>
                            <Box className="select-div" width="180px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    // defaultValue="all"
                                    value={selectedProductId}
                                    onChange={(event) =>
                                        setSelectedProducts(event.target.value)
                                    }
                                    required
                                >
                                    <option value="" disabled>
                                        Select Product
                                    </option>
                                    {selectedProducts ? (
                                        selectedProducts.map((event) => (
                                            <option value={event.id}>{event.product_name}</option>
                                        ))
                                    ) : (
                                        <option>{"No Data Found"}</option>
                                    )}
                                </select>
                            </Box>
                            <Box className="select-div" width="153px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    // defaultValue="all"
                                    value={selectedSizeId}
                                    onChange={(event) =>
                                        setSelectedSizeId(event.target.value)
                                    }
                                    required
                                >
                                    <option value="" disabled>
                                        Select Size
                                    </option>
                                    {selectedSize ? (
                                        selectedSize.map((event) => (
                                            <option value={event.id}>{event.size}</option>
                                        ))
                                    ) : (
                                        <option>{"No Data Found"}</option>
                                    )}
                                </select>
                            </Box>
                            <Box className="select-div" width="140px">
                                <select
                                    className="select-form"
                                    id="selectedClass"
                                    value={selectYear || `FY - ${new Date().getFullYear()}`}
                                    onChange={(event) => setSelectYear(event.target.value)}
                                    required
                                >
                                    <option
                                        value={`FY - ${new Date().getFullYear()}`}
                                        disabled
                                        hidden
                                    >
                                        FY - {new Date().getFullYear()}
                                    </option>
                                    <option value="all">All</option>
                                    {[...Array(10)].map((_, index) => {
                                        const year = new Date().getFullYear() - index;
                                        return (
                                            <option key={year} value={year}>
                                                {year}
                                            </option>
                                        );
                                    })}
                                </select>
                            </Box>
                            <Box className="icon-div">
                                <img src={images.pdfDownloadIcon} /></Box>
                        </div>
                    </div>
                    <div className="d-flex justify-content-between batchNo p-card">
                        <h4>
                            <b>Total Accepted Pairs After Stripping</b>
                        </h4>
                    </div>
                    <div className="production-qty production-qty-subproduction">

                        <SubProductionChart
                            selectRange={selectRange}
                            prodResult={prodResult}
                            startDate={startDate}
                            endDate={endDate}
                            inputValues={inputValues}
                        />
                    </div>

                    <div className="responsive-table production-table">
                        <Table aria-label="Analytics" style={{ backgroundColor: "#FFFF" }}>
                            <TableHead>
                                <TableRow>
                                    <TableCell style={{ padding: "16px 20px", lineHeight: "1", fontSize: "18px" }}>Parameters</TableCell>
                                    {selectRange
                                        ? selectRange.map((month) => (
                                            <TableCell key={month.id} style={{ lineHeight: "1", fontSize: "18px" }}>
                                                {month.label}
                                            </TableCell>
                                        ))
                                        : ""}
                                </TableRow>
                            </TableHead>
                            <TableBody className="subproduction-tablebody">
                                <TableRow className="subproduction-tablebody-cell">
                                    <TableCell>
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="rejectedparam-btn m-1"></span>Produced Pair
                                            in nos
                                        </div>
                                    </TableCell>
                                    {prodResult.length
                                        ? prodResult.map((e) => (
                                            <TableCell>{e.produced_pair_in_nos}</TableCell>
                                        ))
                                        : null}
                                </TableRow>
                                <TableRow className="subproduction-tablebody-cell">
                                    <TableCell>
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="produced-btn m-1"></span> Cum - Prod Pairs
                                            Till Month1
                                        </div>
                                    </TableCell>
                                    {prodResult.length
                                        ? prodResult.map((value, index) => {
                                            return (
                                                <TableCell>{value.cum_prods_till_month_1}</TableCell>
                                            );
                                        })
                                        : null}
                                </TableRow>

                                <TableRow className="subproduction-tablebody-cell">
                                    <TableCell>
                                        {" "}
                                        <div
                                            style={{ color: "black", marginRight: "25px" }}
                                            className="d-flex align-items-center"
                                        >
                                            <span className="target-btn m-1"></span> Target
                                        </div>
                                    </TableCell>

                                    {prodResult.length
                                        ? prodResult.map((e, index) => (
                                            <TableCell>
                                                <input
                                                    type="number"
                                                    className="input-number-production"
                                                    value={inputValues[index] || ""}
                                                    onChange={(event) => {
                                                        const newInputValues = [...inputValues];
                                                        newInputValues[index] = event.target.value;
                                                        setInputValues(newInputValues);
                                                    }}
                                                />
                                            </TableCell>
                                        ))
                                        : null}
                                </TableRow>
                            </TableBody>
                        </Table>
                    </div>
                </Container>
            </div>

        </>
    )
}

export default SubProduction;